module.exports = __webpack_public_path__ + "img/pr-7.511f4b95.png";